import { AcademicRecordDetails } from './components/show/AcademicRecordDetails';
import { AcademicRecordEquivalencyDetails } from './components/show/AcademicRecordEquivalencyDetails';
import { Card, Divider } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import { IAcademicRecordEquivalency } from 'interfaces/academic_record_equivalencies';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { ShowLayout } from '../../../components/layout/layout/ShowLayout';
import { StudentInfo } from './components/show/StudentInfo';
import { useShow } from '@refinedev/core';

export const AcademicRecordEquivalencyShow = () => {
  const { queryResult } = useShow<IAcademicRecordEquivalency>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader title="Visualizar Equivalência" icon={FolderOutlined} />
      <Card>
        {record && (
          <>
            <Divider orientation="left" orientationMargin="0">
              Informações do Aluno
            </Divider>

            <StudentInfo
              user={record?.course_enrollment.user}
              course={record?.course_enrollment.course}
            />

            <Divider orientation="left" orientationMargin="0" className="!pt-4">
              Histórico Acadêmico de Origem
            </Divider>

            {record?.origin_academic_record && (
              <>
                <AcademicRecordDetails
                  academic_record={record?.origin_academic_record}
                />
              </>
            )}

            <Divider orientation="left" orientationMargin="0" className="!pt-4">
              Histórico Acadêmico de Destino
            </Divider>

            <AcademicRecordEquivalencyDetails record={record} />
          </>
        )}
      </Card>
    </ShowLayout>
  );
};
